module.exports = __webpack_public_path__ + "img/lms-reason-3.3fbb2023.png";